export const getUser = (state) => (state.user.get("id") ? state.user : null);

export const getIsAdmin = (state) => state.user.get("isAdmin");

export const getUserName = (state) => ({
  firstName: state.user.get("first_name"),
  lastName: state.user.get("last_name"),
});

export const getUserFullName = (state) => {
  const { firstName, lastName } = getUserName(state);
  return [lastName, firstName].filter((name) => !!name).join(" ");
};

export const getUserEmail = (state) => state.user.get("email");
